import React from 'react';
import PropTypes from 'prop-types';
import Collapse from './Collapse';
import Panel from './Panel';
Collapse.Panel = Panel;
export default Collapse;

Collapse.defaultProps = {
  accordion: false,
  bordered: true,
  destroyInactivePanel: false,
  ghost: false,
  delay: 500
};
Collapse.propTypes = {
  /** 手风琴模式 */
  accordion: PropTypes.bool,
  /** 当前激活 tab 面板的 key */
  activeKey: PropTypes.array,
  /** 所有子面板是否可折叠或指定可折叠触发区域 */
  collapsible: PropTypes.oneOf(['header', 'disabled', 'icon']),
  /** 默认激活 tab 面板的 key */
  defaultActiveKey: PropTypes.array,
  /** 销毁折叠隐藏的面板 */
  destroyInactivePanel: PropTypes.bool,
  /** 自定义切换图标 */
  expandIcon: PropTypes.node,
  /** 设置图标位置 */
  expandIconPosition: PropTypes.oneOf(['left', 'right']),
  /** 折叠面板透明且无边框 */
  ghost: PropTypes.bool,
  /** 切换面板的回调 */
  onChange: PropTypes.func,
  /** 空状态图标 */
  emptyIcon: PropTypes.any,
  /** 空状态文案 */
  noDataTip: PropTypes.string,
  /** loading状态 */
  loading: PropTypes.bool,
  /** 延迟loading时长 */
  delay: PropTypes.bool,
  /** loading状态提示文案 */
  loadingTip: PropTypes.string,
  /** 无边框模式 */
  ghost: PropTypes.bool
};
